import { AfterViewInit, Directive, ElementRef, inject } from '@angular/core'

import { FlxInfoHelperComponent } from '@flowx/angular-ui-toolkit'
import { theme } from '@flowx/core-sdk'
import { ThemeComponent, getComponentStyles } from '@flowx/core-theme'

@Directive({
  selector: 'flx-info-helper',
})
export class FlxHelperTooltipThemeDirective implements AfterViewInit {
  #element = inject(ElementRef).nativeElement as HTMLElement
  #helperComponent = inject(FlxInfoHelperComponent)

  ngAfterViewInit(): void {
    const styleClasses = getComponentStyles(ThemeComponent.HelperTooltip, theme())
    this.#element.classList.add(styleClasses, 'flx-themed')

    // subscription here automatically ends on directive destroy (signal output)
    this.#helperComponent.tooltip().showTooltip.subscribe(({ hostElement }) => {
      hostElement.classList.add(styleClasses, 'flx-themed')

      // TODO: this is a temporary way to get the unique id of the host element for custom style
      // this will improve once we have emotion classes for custom styles as well
      const hostUniqueId = this.#element.parentElement.parentElement.dataset['uniqueid']
      hostElement.dataset['uniqueid'] = hostUniqueId
    })
  }
}
